module.exports = __webpack_public_path__ + "static/media/arunlal.01dd7087.jpg";